var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-list-wrap"},[_c('template-search-list',{attrs:{"listApi":_vm.listApi,"buttonOption":_vm.buttonOption,"defaultSortBy":_vm.defaultSortBy,"initialSearchFilter":_vm.initialSearchFilter,"reload":_vm.reload,"searchUpdated":false},on:{"searchFilter":_vm.getSearchFilter,"showDetail":_vm.showDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }